import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import Clock from "../clock/clock";


export const iconStyle = {
    fontSize: 15,
    marginTop: 0.5,
}

export const AIBHeader = [
    {
        visible: true,
        field: '',
        title: '',
        sort: false,
        filter: false,
        type: 'checkbox',
        isUp: false,
        width: 20,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'order',
        title: '#',
        sort: false,
        filter: false,
        type: 'number',
        isUp: false,
        width: 30,
        value: false,
        restore: true,
        align: 'right'
    },
    {
        visible: true,
        field: 'play',
        title: 'Play',
        sort: false,
        filter: true,
        type: 'video',
        isUp: false,
        width: 250,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'sentence',
        title: 'Sentences',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 400,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'sec',
        title: 'Sec',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 35,
        value: false,
        restore: false,
        align: 'right'
    },
    {
        visible: true,
        field: 'length',
        title: 'Len',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 35,
        value: false,
        restore: false,
        align: 'right'
    },
    {
        visible: true,
        field: 'categories',
        title: 'Categories',
        sort: false,
        filter: true,
        type: 'listCategory',
        isUp: false,
        width: 300,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'duration',
        title: <Clock />,
        sort: false,
        filter: false,
        type: 'icon',
        isUp: false,
        width: 40,
        value: false,
        restore: false,
        align: 'right'
    },
]

export const categoriesHeader = [
    {
        visible: true,
        field: '',
        title: '',
        sort: false,
        filter: false,
        type: 'checkbox',
        isUp: false,
        width: 20,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'order',
        title: '#',
        sort: false,
        filter: false,
        type: 'number',
        isUp: false,
        width: 30,
        value: false,
        restore: true,
        align: 'right'
    },
    {
        visible: true,
        field: 'play',
        title: 'Play',
        sort: false,
        filter: true,
        type: 'video',
        isUp: false,
        width: 250,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'sentence',
        title: 'Sentences',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 400,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'categories',
        title: 'Categories',
        sort: false,
        filter: true,
        type: 'listCategory',
        isUp: false,
        width: 300,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'sec',
        title: 'Sec',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 35,
        value: false,
        restore: false,
        align: 'right'
    },
    {
        visible: true,
        field: 'length',
        title: 'Len',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 35,
        value: false,
        restore: false,
        align: 'right'
    },
    {
        visible: true,
        field: 'duration',
        title: <Clock />,
        sort: false,
        filter: false,
        type: 'icon',
        isUp: false,
        width: 40,
        value: false,
        restore: false,
        align: 'right'
    },
]

export const autoHighlightHeader = [
    {
        visible: true,
        field: '',
        title: '',
        sort: false,
        filter: false,
        type: 'checkbox',
        isUp: false,
        width: 20,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'order',
        title: '#',
        sort: false,
        filter: false,
        type: 'number',
        isUp: false,
        width: 30,
        value: false,
        restore: true,
        align: 'right'
    },
    {
        visible: true,
        field: 'play',
        title: 'Play',
        sort: false,
        filter: false,
        type: 'video',
        isUp: false,
        width: 200,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'sentence',
        title: 'Sentence',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 100,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'sec',
        title: 'Sec',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 35,
        value: false,
        restore: false,
        align: 'right'
    },
    {
        visible: true,
        field: 'length',
        title: 'Len',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 35,
        value: false,
        restore: false,
        align: 'right'
    },
    {
        visible: true,
        field: 'rank',
        title: 'Rank',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 100,
        value: false,
        restore: false,
        align: 'right'
    },
    {
        visible: true,
        field: 'duration',
        title: <Clock />,
        sort: false,
        filter: false,
        type: 'icon',
        isUp: false,
        width: 40,
        value: false,
        restore: false,
        align: 'right'
    },

]

export const contentModerationHeader = [
    {
        visible: true,
        field: '',
        title: '',
        sort: false,
        filter: false,
        type: 'checkbox',
        isUp: false,
        width: 20,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'order',
        title: '#',
        sort: false,
        filter: false,
        type: 'number',
        isUp: false,
        width: 30,
        value: false,
        restore: true,
        align: 'right'
    },
    {
        visible: true,
        field: 'play',
        title: 'Play',
        sort: false,
        filter: false,
        type: 'video',
        isUp: false,
        width: 200,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'sentence',
        title: 'Sentence',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 300,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'label',
        title: 'Label',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 150,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'sec',
        title: 'Sec',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 35,
        value: false,
        restore: false,
        align: 'right'
    },
    {
        visible: true,
        field: 'length',
        title: 'Len',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 35,
        value: false,
        restore: false,
        align: 'right'
    },
    {
        visible: true,
        field: 'duration',
        title: <Clock />,
        sort: false,
        filter: false,
        type: 'icon',
        isUp: false,
        width: 40,
        value: false,
        restore: false,
        align: 'right'
    }

]
export const entitiesHeader = [
    {
        visible: true,
        field: '',
        title: '',
        sort: false,
        filter: false,
        type: 'checkbox',
        isUp: false,
        width: 20,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'order',
        title: '#',
        sort: false,
        filter: false,
        type: 'number',
        isUp: false,
        width: 30,
        value: false,
        restore: true,
        align: 'right'
    },
    {
        visible: true,
        field: 'play',
        title: 'Play',
        sort: false,
        filter: false,
        type: 'video',
        isUp: false,
        width: 200,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'sentence',
        title: 'Sentences',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 300,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'entity_type',
        title: 'Type',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 150,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'sec',
        title: 'Sec',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 35,
        value: false,
        restore: false,
        align: 'right'
    },
    {
        visible: true,
        field: 'length',
        title: 'Len',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 35,
        value: false,
        restore: false,
        align: 'right'
    },
    {
        visible: true,
        field: 'duration',
        title: <Clock />,
        sort: false,
        filter: false,
        type: 'icon',
        isUp: false,
        width: 40,
        value: false,
        restore: false,
        align: 'right'
    }


]

export const sentencesHeader = [

    {
        visible: true,
        field: '',
        title: '',
        sort: false,
        filter: false,
        type: 'checkbox',
        isUp: false,
        width: 20,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'order',
        title: '#',
        sort: false,
        filter: false,
        type: 'number',
        isUp: false,
        width: 30,
        value: false,
        restore: true,
        align: 'left'
    },
    {
        visible: true,
        field: 'speaker',
        title: <RecordVoiceOverIcon sx={iconStyle} />,
        sort: true,
        filter: true,
        type: 'icon',
        isUp: false,
        width: 20,
        value: false,
        restore: false,
        align: 'center'
    },
    {
        visible: true,
        field: 'sentiment',
        title: <EmojiEmotionsIcon sx={iconStyle} />,
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 35,
        value: true,
        restore: false,
        align: 'left'
    },

    {
        visible: true,
        field: 'play',
        title: 'Play',
        sort: false,
        filter: true,
        type: 'video',
        isUp: false,
        width: 300,
        value: false,
        restore: false,
        align: 'left'
    },


    {
        visible: true,
        field: 'sentence',
        title: 'Sentences',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 250,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'sec',
        title: 'Sec',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 35,
        value: false,
        restore: false,
        align: 'right'
    },
    {
        visible: true,
        field: 'length',
        title: 'Len',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 35,
        value: false,
        restore: false,
        align: 'right'
    },
    {
        visible: true,
        field: 'question',
        title: '?',
        sort: true,
        filter: true,
        type: 'boolean',
        isUp: false,
        width: 30,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'verbs',
        title: 'Actions',
        subtitle: 'Verbs',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 60,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'adjectives',
        title: 'Descriptions',
        subtitle: 'Adjectives',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 60,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'nouns',
        title: 'Things',
        subtitle: 'Nouns',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 65,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: false,
        field: 'start',
        title: 'Start',
        sort: true,
        filter: true,
        type: 'time',
        isUp: false,
        width: 100,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: false,
        field: 'stop',
        title: 'Stop',
        sort: true,
        filter: true,
        type: 'time',
        isUp: false,
        width: 100,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'duration',
        title: <Clock />,
        sort: false,
        filter: false,
        type: 'icon',
        isUp: false,
        width: 40,
        value: false,
        restore: false,
        align: 'right'
    },
]

export const downloadedHeader = [
    {
        visible: true,
        field: '',
        title: '',
        sort: false,
        filter: false,
        type: 'none',
        isUp: false,
        width: '5%',
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'title',
        title: 'Title',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: '25%',
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'play',
        title: 'Play',
        sort: false,
        filter: false,
        type: 'video',
        isUp: false,
        width: '300',
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'task_status',
        title: 'Task',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: '10%',
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'downloaded',
        title: 'Downloaded',
        sort: true,
        filter: true,
        type: 'dateTime',
        isUp: false,
        width: '15',
        value: false,
        restore: false,
        align: 'left'
    },

]

export const myCreationHeader = [

    {
        visible: true,
        field: 'title',
        title: 'Title',
        sort: true,
        filter: false,
        type: 'string',
        isUp: false,
        width: 180,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'description',
        title: 'Description',
        sort: true,
        filter: false,
        type: 'string',
        isUp: false,
        width: 180,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'video',
        title: 'Play',
        sort: false,
        filter: false,
        type: 'video',
        isUp: false,
        width: 350,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'download',
        title: 'Download',
        sort: false,
        filter: false,
        type: 'download',
        isUp: false,
        width: 80,
        value: false,
        restore: false,
        align: 'center'
    },

    {
        visible: true,
        field: 'type',
        title: 'Type',
        sort: true,
        filter: false,
        type: 'string',
        isUp: false,
        width: 80,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'created',
        title: 'Created',
        sort: true,
        filter: false,
        type: 'date',
        isUp: false,
        width: 150,
        value: false,
        restore: false,
        align: 'left'
    },



]


